/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const NumOrStringPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
